<template>
    <div class="d-flex flex-wrap p-0 col-11">

<!--        <form-field :label="getFieldLabel('forLife')"-->
<!--                    class="col-xs-12 col-sm-8 col-md-4 col-lg-3 p-0 mr-0 mr-sm-3 mt-3 mb-3"-->
<!--                    :value="readonlyValue"-->
<!--                    :editable="isEditable('forLife')"-->
<!--                    :feedback="liveFeedback('forLife')">-->
<!--            <template #field>-->
<!--                <b-form-checkbox  size="lg" v-model="form.forLife" @change="onForLifeChange" switch >-->
<!--                    <span v-if="form.forLife">Да</span>-->
<!--                    <span v-else>Нет</span>-->
<!--                </b-form-checkbox>-->
<!--            </template>-->
<!--        </form-field>-->

        <form-field
                :label="getFieldLabel('address')"
                class="col-12 m-0 p-0 required"
                :editable="isEditable('address') && Boolean(selectedMunicipality)"
                :feedback="liveFeedback('address')"
                :value="form.addressHumanReadable ? form.addressHumanReadable : 'Не указан'">

            <template #value>
                <map-box ref="map" :coordinates="selectedCoordinates" style="width: 100%; height: 500px"/>
                <div class="clearfix p-1"></div>
                <div class="col-12 p-0 m-0 d-flex align-items-center">
                    <div class="flex-grow-1 mr-2">{{ form.addressHumanReadable ? form.addressHumanReadable : 'Не указан' }}</div>
                    <b-button variant="link" class="p-0" @click="onAddressFocus">
                        <img :src="focus" width="32"/>
                    </b-button>
                </div>
            </template>

            <template #field>
                <div class="clearfix p-1"></div>
<!--                <div class="clearfix p-2"></div>-->
                <map-box ref="map"
                         :coordinates="selectedCoordinates"
                         :center-lat="selectedMunicipality ? parseFloat(selectedMunicipality.lat) : 68.9614"
                         :center-lon="selectedMunicipality ? parseFloat(selectedMunicipality.lon) : 33.0955"
                         v-on:map-clicked="onMapClicked" style="width: 100%; height: 500px"/>
                <div class="clearfix p-1"></div>
                <div class="col-12 p-0 m-0 d-flex">
                    <single-select name="address"
                                   ref="address"
                                   class="flex-grow-1 mr-2"
                                   v-model="form.addressObject"
                                   :url="getAddressUrl"
                                   :label="getFieldLabel('address')"
                                   label-key="human_readable_address"
                                   :state="getValidationClass('address')"
                                   :has-pagination="false"
                                   :initial-filters="addressInitialFilters"
                                   placeholder="Поиск адреса в выбранном муниципалитете"
                                   v-on:select-search-init="onAddressSearchStart"
                                   v-on:select-changed="onAddressChanged"
                                   v-on:select-set="onAddressSet"
                                   v-on:select-cleared="onModelObjectSingleSelectCleared" />
                    <b-button variant="link" class="p-0" @click="onAddressFocus">
                        <img :src="focus" width="32"/>
                    </b-button>
                </div>
            </template>
        </form-field>

<!--        <form-field :label="getFieldLabel('forLife')"-->
<!--                    class="col-xs-12 col-sm-8 col-md-4 col-lg-3 p-0 mr-0 mr-sm-3 mt-3 mb-3"-->
<!--                    :value="readonlyValue"-->
<!--                    :editable="getAbility('forLife')"-->
<!--                    :feedback="liveFeedback('forLife')">-->
<!--            <template #field>-->
<!--                <b-form-checkbox  size="lg" v-model="form.forLife" @change="onForLifeChange" switch >-->
<!--                    <span v-if="form.forLife">Да</span>-->
<!--                    <span v-else>Нет</span>-->
<!--                </b-form-checkbox>-->

<!--            </template>-->
<!--        </form-field>-->

    </div>
</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
    import {KeepingEventAttributes} from "./keeping";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
    import MapBox from "@/components/Map/MapBox.vue";
    import SingleSelect from "@/components/Select/SingleSelect.vue";
    import {MapMixin} from "@/components/Map/mapMixin";
    import api from "@/api";
    import httpClient from "@/http";
    import {mapGetters} from "vuex";
    import MapMunicipalityList from "@/components/Map/MapMunicipalityList.vue";

    export default {
        name: "KeepingAttributes",
        components: {MapMunicipalityList, SingleSelect, MapBox, FormField },
        mixins: [ObjectComponentMixin, AttributeMixin, MapMixin],
        computed: {
            readonlyValue() {
                return this.object.forLife ? 'Да' : 'Нет'
            },
        },
        methods: {
            onForLifeChange() {
                this.$v.form.forLife.$touch();
            },
            onMunicipalityChanged(item) {
                const aboutToChange = this.toggleSelectedMunicipality(item);
                if (aboutToChange) {
                    this.form['address'] = null;
                    this.form['addressObject'] = {};
                    this.$v.form.address.$touch();
                    this.selectedCoordinates = {};
                    this.nearestAddressData = {}
                }
            },
            cancelAttributeChanges() {
                this.cancelChanges()
                this.setMapCoordinates(this.object.coordinates)
            }
        },
        beforeMount() {
            this.objectClass = KeepingEventAttributes;
            this.initialize();
            if (this.eventData && this.eventData.attributes) {
               this.initObjectParams.forLife = this.eventData.attributes.forLife;
            }
        },
        mounted() {
            const vm = this;
            if (!vm.eventId && vm.animal && vm.animal.lastCatchingId) {
                vm.onMount();
                httpClient.get(api.events.address.list(api.events.default.detail(vm.animal.lastCatchingId)))
                    .then((response) => {
                        const catchingData = response.data;
                        vm.initObjectParams.address = catchingData.address;
                        vm.initObjectParams.addressObject = catchingData['address_object'];
                        vm.initObjectParams.lat = catchingData.attributes.lat ? catchingData.attributes.lat : catchingData['address_object'].lat;  // TODO: для отлова тоже хранить фактическую точку
                        vm.initObjectParams.lon = catchingData.attributes.lon ? catchingData.attributes.lon : catchingData['address_object'].lon;
                        vm.$emit('init-municipality-selected', catchingData['address_object']['municipality_object'])
                        return vm.resetForm()
                    })
                    .then(() => {
                        vm.setMapCoordinates(vm.object.coordinates)

                    });
            } else {
                vm.resetForm().then(() => {
                    vm.setMapCoordinates(vm.object.coordinates)
                    if (vm.object.addressObject) {
                        vm.$emit('init-municipality-selected', vm.object.addressObject['municipality_object'])
                    }
                });
            }

        }
    }
</script>

<style scoped lang="scss">

</style>